<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path d="M10 14L14 10" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" />
  <path
    d="M8.5 16.5L6.5 18.5C5.39543 19.6046 3.60457 19.6046 2.5 18.5C1.39543 17.3954 1.39543 15.6046 2.5 14.5L4.5 12.5"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
  />
  <path
    d="M15.5 7.5L17.5 5.5C18.6046 4.39543 20.3954 4.39543 21.5 5.5C22.6046 6.60457 22.6046 8.39543 21.5 9.5L19.5 11.5"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
  />
</svg>
